import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import GSTSummary from './GSTSummary';
import GSTInvoice from './GSTInvoice';
import GSTReturn from './GSTReturn';
import GSTPurchase from './GSTPurchase';

const GST_TABS = [
  { label: 'Summary', value: 0 },
  { label: 'GST Invoice', value: 1 },
  { label: 'GST Purchase', value: 3 },
  { label: 'GST Return', value: 2 }
];

export default function GST() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        sx={{
          mb: 2,
          borderBottom: '1px solid #eaedf1',
          '& .MuiTab-root': {
            minHeight: 40,
            py: 1,
            textTransform: 'none',
            fontSize: 13,
            fontWeight: 500
          },
          '& .Mui-selected': { color: '#0d4689', fontWeight: 700 },
          '& .MuiTabs-indicator': { backgroundColor: '#4fbbc8' }
        }}
      >
        {GST_TABS.map((t) => (
          <Tab key={t.value} label={t.label} value={t.value} />
        ))}
      </Tabs>

      {activeTab === 0 && <GSTSummary />}
      {activeTab === 1 && <GSTInvoice />}
      {activeTab === 2 && <GSTReturn />}
      {activeTab === 3 && <GSTPurchase />}
    </Box>
  );
}
